/**
 * @name string-collapse-leading-whitespace
 * @fileoverview Collapse the leading and trailing whitespace of a string
 * @version 6.1.4
 * @author Roy Revelt, Codsen Ltd
 * @license MIT
 * {@link https://codsen.com/os/string-collapse-leading-whitespace/}
 */

var m="6.1.4";var E=m;function D(l,u=1){let $="\xA0";function g(e){return Array.from(e).reverse().join("")}function a(e,t,o){let r=o?`
`:"\r",i=o?"\r":`
`;if(!e)return e;let p=0,c=0,s="";for(let n=0,f=e.length;n<f;n++)(e[n]===r||e[n]===i&&e[n-1]!==r)&&c++,`\r
`.includes(e[n])||e[n]===$?(p=0,e[n]===$?s+=e[n]:e[n]===r?c<=t&&(s+=e[n],e[n+1]===i&&(s+=e[n+1],n++)):e[n]===i&&e?.[n-1]!==r&&c<=t&&(s+=e[n])):(p++,!e[n+1]&&!c&&(s+=" "));return s}if(typeof l=="string"&&l.length){let e=1;typeof+u=="number"&&Number.isInteger(+u)&&+u>=0&&(e=+u);let t="",o="";if(!l.trim())t=l;else if(!l[0].trim()){for(let r=0,i=l.length;r<i;r++)if(l[r].trim()){t=l.slice(0,r);break}}if(l.trim()&&(l.slice(-1).trim()===""||l.slice(-1)===$)){for(let r=l.length;r--;)if(l[r].trim()){o=l.slice(r+1);break}}return`${a(t,e,!1)}${l.trim()}${g(a(g(o),e,!0))}`}return l}export{D as collWhitespace,E as version};
